import { Controller, type Control, type FieldValues, type Path } from 'react-hook-form';
import { Label, Input } from '@shared/components';

interface Props<T extends FieldValues> {
    control: Control<T>;
}

export function CustomerCompanyFields<T extends FieldValues>({ control }: Props<T>) {
    return (
        <>
            <Controller
                name={'businessName' as Path<T>}
                control={control}
                render={({ field, fieldState }) => (
                    <div>
                        <Label htmlFor="businessName">Business Name</Label>
                        <Input
                            id="businessName"
                            type="text"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    </div>
                )}
            />
            <Controller
                name={'vatNumber' as Path<T>}
                control={control}
                render={({ field, fieldState }) => (
                    <div>
                        <Label htmlFor="vatNumber">VAT Number</Label>
                        <Input
                            id="vatNumber"
                            type="text"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    </div>
                )}
            />
        </>
    );
}
